module.exports = __webpack_public_path__ + "img/zzzj2.f91b5d1f.png";